// @flow strict

import React, { type Node, Fragment } from 'react';

import type { SocialMediaSVGProps } from '~components/icons/social-media/social-media-icon';

/**
 * Youtube icon
 *
 * @param {SocialMediaSVGProps} props - icon props
 *
 * @returns {Node}
 */
export const YoutubeIcon = ({ color }: SocialMediaSVGProps): Node => {
  return (
    <Fragment>
      <defs>
        <path
          id="youtube__a"
          d="M0.007 0.004L19.714 0.004 19.714 12.95 0.007 12.95z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H34.858V34.037H0z" />
        <g transform="translate(7 12)">
          <mask id="youtube__b" fill="#fff">
            <use xlinkHref="#youtube__a" />
          </mask>
          <path
            className="youtube"
            fill={color}
            d="M17.56.387C16.021 0 9.856 0 9.856 0S3.692 0 2.155.387C1.307.599.639 1.227.412 2.022 0 3.465 0 6.475 0 6.475s0 3.01.412 4.452c.227.796.895 1.423 1.743 1.636 1.537.387 7.702.387 7.702.387s6.165 0 7.702-.387c.849-.213 1.517-.84 1.743-1.636.412-1.442.412-4.452.412-4.452s0-3.01-.412-4.453C19.076 1.226 18.408.6 17.56.387z"
            mask="url(#youtube__b)"
          />
          <path
            fill="#fffffe"
            d="M8.05 9.791L8.05 3.264 13.8 6.527 8.05 9.791"
          />
        </g>
      </g>
    </Fragment>
  );
};
